import { gql } from '@apollo/client';

const printOrderHistory = gql`
  query OrderHistoryPrint($orderGroupId: Int!, $orderIds: [Int!]) {
    orderHistoryPrint(orderGroupId: $orderGroupId, orderIds: $orderIds)
  }
`;

export default printOrderHistory;
